import { Address } from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  Modal,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { StripeSetupIntent } from "../../../components/stripe/StripeSetupIntent";

interface AddPaymentProfileModalProps {
  customerAccountId: string;
  defaultAddress?: Address;
  handleClose: () => void;
  includeTitle?: boolean;
  initialPaymentProfileCount: number;
}

export function AddPaymentProfileModal(props: AddPaymentProfileModalProps) {
  const { handleClose } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen testID="add-payment-profile-modal">
      <Dialog width="456px">
        {() => (
          <>
            <DialogHeader onClose={handleClose}>
              {t("Add payment profile")}
            </DialogHeader>
            <DialogContent>
              <StripeSetupIntent
                customerAccountId={props.customerAccountId}
                defaultAddress={props.defaultAddress}
                handleClose={handleClose}
                includeTitle={props.includeTitle}
                initialPaymentProfileCount={props.initialPaymentProfileCount}
              />
            </DialogContent>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
